import { render, staticRenderFns } from "./BlogLinkSuggestion.vue?vue&type=template&id=50d18b4a&scoped=true"
import script from "./BlogLinkSuggestion.vue?vue&type=script&lang=js"
export * from "./BlogLinkSuggestion.vue?vue&type=script&lang=js"
import style0 from "./BlogLinkSuggestion.vue?vue&type=style&index=0&id=50d18b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d18b4a",
  null
  
)

export default component.exports